import Vue from 'vue'
import Cookies from 'js-cookie'
import store from './store'
import router from './router'
import App from './components/App'
import axios from 'axios'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
import 'swiper/swiper-bundle.css'
import './permission' // permission control

	Vue.use(VueAwesomeSwiper)
Vue.prototype.axios = axios
Vue.use(Element);
const app = new Vue({
  router,
  store,
  template: '<App/>',
  components: { App },
  render: h => h(App)
}).$mount('#app')

// 将Vue实例暴露到全局，以便404重定向脚本可以访问路由器
window.app = app;



// WEBPACK FOOTER //
// ./src/main.js